namespace GeniuzPOS.ReportMasterData {
    export interface Report_1501_NRow {
        Id?: string;
        Year?: string;
        CatCode?: string;
        CatName?: string;
        TypeSum?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace Report_1501_NRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1501_N';
        export const deletePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const insertPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const readPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const updatePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            Year = "Year",
            CatCode = "CatCode",
            CatName = "CatName",
            TypeSum = "TypeSum",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
